import { useEffect, useState } from 'react';
import { CASE_DETAILS } from 'constants/tickets';
import { get } from 'ravenjs/utils/lodash';
import _uniqBy from 'lodash/uniqBy';

const defaultFilters = {
    'page[size]': 25,
    'page[number]': 1,
    'stats[total]': 'count',
    'filter[with_expired][eq]': true,
    sort: '-updated_at',
};

export function usePreppedAnswers({ currentUserId = null, fetchPreppedAnswers, type = 'answer' }) {
    const [data, setData] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [favFilter, setFavFilter] = useState(null);
    const [typeFilter, saveTypeFilter] = useState(null);

    const formatResponse = responseData =>
        responseData.map(({ attributes, ...rest }) => {
            return {
                ...attributes,
                ...rest,
            };
        });

    useEffect(() => {
        saveTypeFilter({
            'filter[kind]': type,
        });
    }, [type]);

    useEffect(() => {
        setFavFilter(
            currentUserId
                ? {
                      'filter[favorited_by_ids]': [currentUserId],
                  }
                : {}
        );
    }, [currentUserId, type]);

    useEffect(() => {
        async function fetchPreppedAnswersData() {
            try {
                setLoading(true);
                const response = await fetchPreppedAnswers({
                    ...defaultFilters,
                    ...favFilter,
                    ...typeFilter,
                });
                const responseData = get(response, 'data', []);
                let formattedResponse = formatResponse(responseData);

                if (type === CASE_DETAILS.ADD_PREPPED_ANSWER.TYPES.SIGNATURE.value) {
                    const defaultSignatureResponse = await fetchPreppedAnswers({
                        'filter[default][eq]': true,
                    });

                    const defaultSignatureData = get(defaultSignatureResponse, 'data', []);

                    formattedResponse = _uniqBy(
                        [...formatResponse(defaultSignatureData), ...formattedResponse],
                        'id'
                    );
                }

                setData(formattedResponse);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        }

        if (typeFilter && favFilter) {
            fetchPreppedAnswersData();
        }
    }, [favFilter, fetchPreppedAnswers, typeFilter, type]);

    return { data, error, loading };
}
